import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"no-data"},[_c(VCardText,[_c(VImg,{staticClass:"no-data__img mt-12 mb-8 mx-auto",attrs:{"src":_vm.items[_vm.type] ? _vm.items[_vm.type].path : ''}}),_c(VCardTitle,{staticClass:"text-center"},[_c('p',[_vm._v(_vm._s(_vm.items[_vm.type].text))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }